/* eslint-env browser */
import { merge } from 'lodash';
import query from 'component-query';
import defaults from './defaults.json';

const slice = Array.prototype.slice;

export default function metas(tags) {
  const title = query('title');
  const ogs = slice.call(query.all('meta[name^="twitter:"]'));
  const _defaults = merge({}, defaults);
  const obj = merge(_defaults, tags);

  ogs.forEach(remove);
  Object.keys(obj).forEach(insertMetasFor(obj));
}

function remove(og) {
  og.parentNode.removeChild(og);
}

function insertMetasFor(obj) {
  return function insertMetaFor(tag) {
    const content = obj[tag];

    if (typeof content === 'string') {
      return insert(tag, content);
    }

    content.forEach(sub => {
      Object.keys(sub).forEach(prop => {
        insert(`${tag}:${prop}`, sub[prop]);
      });
    });
  };
}

function insert(prop, content) {
  const meta = document.createElement('meta');
  meta.setAttribute('name', prop);
  meta.setAttribute('content', content);
  after(query('title'), meta);
}

function after(node, meta) {
  if (!node.nextSibling) return node.parentNode.appendChild(meta);
  node.parentNode.insertBefore(meta, node.nextSibling);
}



// WEBPACK FOOTER //
// ./src/modules/twittercard/twittercard.js